import { useState } from 'react';
import StickyHeader from '../../components/feature/StickyHeader';
import ConsultationModal from '../../components/feature/ConsultationModal';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesOverview from './components/ServicesOverview';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  const [consultationOpen, setConsultationOpen] = useState(false);

  const openConsultation = () => setConsultationOpen(true);
  const closeConsultation = () => setConsultationOpen(false);

  return (
    <div className="min-h-screen bg-offWhite font-body">
      <StickyHeader onOpenConsultation={openConsultation} />
      <ConsultationModal isOpen={consultationOpen} onClose={closeConsultation} />

      <main>
        <HeroSection onOpenConsultation={openConsultation} />
        <TrustBar />
        <ServicesOverview onOpenConsultation={openConsultation} />
        <AIAnswerBlock />
        <ProcessSection onOpenConsultation={openConsultation} />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials onOpenConsultation={openConsultation} />
        <FAQSection />
        <FinalCTA onOpenConsultation={openConsultation} />
      </main>

      <Footer />
    </div>
  );
}
